/**
 * @file DynamicBackButtonComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente de botón dinámico de retroceso
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-09-21
 * @modified 2025-10-17
 * @author Correcta
 * @author Sergio Manjón
 * @copyright © Correcta
 * @license Private
 */

"use client";

import BackButtonComponent from "@/components/ui/BackButtonComponent";
import { useTranslations } from "next-intl";
import { memo, useMemo } from "react";

interface DynamicBackButtonProps {
  labelKey?: string;
  href?: string;
  className?: string;
  disabled?: boolean;
  status?: string;
}

const DynamicBackButtonComponent = memo(
  ({ labelKey = "buttonBackTo", href, ...props }: DynamicBackButtonProps) => {
    const paths = useTranslations("Paths");
    const buttons = useTranslations("Buttons");
    const label = labelKey !== "buttonBackTo" ? labelKey : buttons(labelKey);

    const lastSegment = useMemo(() => {
      if (!href) return "";
      const segments = href.split("/").filter(Boolean);
      return segments.length > 0 ? segments[segments.length - 1] : "";
    }, [href]);

    const translatedSegment = paths(lastSegment);

    const finalLabel = `${label} ${translatedSegment}`;

    return <BackButtonComponent href={href} label={finalLabel} {...props} />;
  },
);

DynamicBackButtonComponent.displayName = "DynamicBackButtonComponent";

export default DynamicBackButtonComponent;
